import { Component, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { DeepLinkService } from './@shared/services/deep-link.service';
import { AuthService } from './@shared/services/auth.service';
import { DadosUsuarioService } from './@shared/services/dados-usuario-service';
import { UsuarioAutenticado } from './@shared/models/auth.models';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('sdg-web');
  constructor(private authService: AuthService,
              private deepLinkService: DeepLinkService,
              private dadosUsuarioService: DadosUsuarioService,
              private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    this.deepLinkService.iniciar();
    const usuarioSalvo = sessionStorage.getItem('UsuarioLogado');

    // Primeiro, processa um possível retorno da autenticação.
    const usuarioAutenticado = await this.authService.handleRedirect();
    if (usuarioAutenticado) {
      sessionStorage.setItem('UsuarioLogado', JSON.stringify(usuarioAutenticado));
      this.dadosUsuarioService.atualizarUsuarioLogon(usuarioAutenticado);
      if (!usuarioSalvo)
        await this.router.navigate(['/home']);
      return;
    }

    if (!usuarioSalvo) {
      await this.router.navigate(['/welcome']);
      return;
    }

    const usuario = JSON.parse(usuarioSalvo) as UsuarioAutenticado;

    if (usuario.nome === 'Visitante') {
      this.dadosUsuarioService.atualizarUsuario(usuario);
      return;
    }

    // Para usuários Microsoft, consulta o estado atual do provedor.
    const usuarioMicrosoft = await this.authService.getUsuario('microsoft');

    if (usuarioMicrosoft) {
      sessionStorage.setItem('UsuarioLogado', JSON.stringify(usuarioMicrosoft));
      this.dadosUsuarioService.atualizarUsuarioLogon( usuarioMicrosoft);
    } else {
      sessionStorage.removeItem('UsuarioLogado');
      await this.router.navigate(['/welcome']);
    }
  }
}
